<template>
  <div class="welfare-container">
    <h2 class="welfare-title">瑞谦福利</h2>
    <div class="welfare-grid">
      <div v-for="item in welfareItems" :key="item.id" class="welfare-item">
        <div class="icon-wrapper">
          <img :src="item.imgUrl" :alt="item.alt" class="welfare-icon" />
        </div>
        <h3 class="welfare-name">{{ item.alt }}</h3>
        <p class="welfare-desc">{{ item.explain }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelfareIcons',
  props: {
    welfareItems: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.welfare-container {
  width: 100%;
  padding: 60px 0;
  background: #f5f5f5;
}

.welfare-title {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 40px;
  position: relative;
}

.welfare-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #1890ff;
  border-radius: 2px;
}

.welfare-grid {
  display: flex;
  flex-wrap: nowrap;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  justify-content: space-between;  /* 平均分配空间 */
}

.welfare-grid::-webkit-scrollbar {
  display: none;  /* Chrome, Safari and Opera */
}

.welfare-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 20px 10px;
  padding: 50px 20px;
  background: #fff;
  transition: all 0.3s ease;
  flex: 1;  /* 改为自适应 */
  min-width: 180px;  /* 设置最小宽度 */
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.welfare-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.welfare-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.welfare-name {
  font-size: 22px;
  font-weight: 500;
  color: rgba(5,85,182,1);
  margin: 20px 0 30px 0;
}

.welfare-desc {
  font-size: 14px;
  color: rgba(51,51,51,1);
  margin: 0;
  white-space: pre-line;
  line-height: 1.4;
}

/* 移除不需要的媒体查询 */
@media (max-width: 768px), (max-width: 480px) {
  .welfare-grid {
    padding: 0 15px;
  }
}
</style>
